import { render } from "./AnnulationPopUp.vue?vue&type=template&id=63dfa1ad&scoped=true"
import script from "./AnnulationPopUp.vue?vue&type=script&lang=js"
export * from "./AnnulationPopUp.vue?vue&type=script&lang=js"

import "./AnnulationPopUp.vue?vue&type=style&index=0&id=63dfa1ad&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63dfa1ad"

export default script